export enum ColumnHeaderType {
  NONE= null,
  TEXT = 'TEXT',
  ICON = 'ICON',
  TEXTICON = 'TEXTICON',
  ICONTEXT = 'ICONTEXT',
}
